var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _g, _path85, _g2, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _g3, _path93, _g4, _path94, _path95, _path96, _g5, _path97, _g6, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _g7, _path107, _g8, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _g9, _path115, _path116, _path117, _path118, _g10, _path119, _g11, _path120, _g12, _path121, _g13, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _g14, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _g15, _path136, _g16, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _g17, _path149, _path150, _path151, _g18, _path152, _path153, _path154, _path155, _g19, _path156, _path157, _path158, _path159, _g20, _path160, _path161, _path162;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 399,
    height: 330,
    viewBox: "0 0 399 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M372.099 90.528C372.099 90.528 346.618 42.655 290.349 35.563C234.08 28.471 194.797 63.045 153.391 80.776C131.707 90.061 106.94 86.455 83.921 90.949C10.316 105.32 -17.411 195.355 13.248 246.557C39.79 290.884 86.505 313.933 157.638 319.252C228.771 324.571 278.671 330.777 342.372 287.337C406.073 243.898 401.827 153.472 372.099 90.528Z",
    fill: "#3FC7F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M372.099 90.528C372.099 90.528 346.618 42.655 290.349 35.563C234.08 28.471 194.797 63.045 153.391 80.776C131.707 90.061 106.94 86.455 83.921 90.949C10.316 105.32 -17.411 195.355 13.248 246.557C39.79 290.884 86.505 313.933 157.638 319.252C228.771 324.571 278.671 330.777 342.372 287.337C406.073 243.898 401.827 153.472 372.099 90.528Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.192 254.738V230.314H49.29V119.049H86.387V143.473H107.162V215.388H157.615V176.038H181.357V197.741H198.824H206.655L207.284 205.89H227.783V173.324H244.106V71.558H284.171V110.908H313.849V1H346.495V182.823H380.625V227.6H387.452",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M63.873 143.147H55.849V151.842H63.873V143.147Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.59 143.147H72.566V151.842H80.59V143.147Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M63.873 161.262H55.849V169.957H63.873V161.262Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.59 161.262H72.566V169.957H80.59V161.262Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.644 161.262H90.62V169.957H98.644V161.262Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.644 179.377H90.62V188.072H98.644V179.377Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.644 197.491H90.62V206.186H98.644V197.491Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.644 215.606H90.62V224.301H98.644V215.606Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.644 233.721H90.62V242.416H98.644V233.721Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.644 251.835H90.62V260.53H98.644V251.835Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M63.873 179.377H55.849V188.072H63.873V179.377Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.59 179.377H72.566V188.072H80.59V179.377Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M63.873 197.491H55.849V206.186H63.873V197.491Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.59 197.491H72.566V206.186H80.59V197.491Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M63.873 215.606H55.849V224.301H63.873V215.606Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.59 215.606H72.566V224.301H80.59V215.606Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M63.873 233.721H55.849V242.416H63.873V233.721Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.096 243.865H19.072V252.56H27.096V243.865Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M142.776 224.301H134.752V232.996H142.776V224.301Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M158.824 224.301H150.8V232.996H158.824V224.301Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.211 11.272H319.187V19.967H327.211V11.272Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.241 11.272H329.217V19.967H337.241V11.272Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.211 29.387H319.187V38.082H327.211V29.387Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.241 29.387H329.217V38.082H337.241V29.387Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.211 47.502H319.187V56.197H327.211V47.502Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.241 47.502H329.217V56.197H337.241V47.502Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.211 65.617H319.187V74.312H327.211V65.617Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.241 65.617H329.217V74.312H337.241V65.617Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.211 83.731H319.187V92.426H327.211V83.731Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.241 83.731H329.217V92.426H337.241V83.731Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.211 101.846H319.187V110.541H327.211V101.846Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.241 101.846H329.217V110.541H337.241V101.846Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.211 119.961H319.187V128.656H327.211V119.961Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.241 119.961H329.217V128.656H337.241V119.961Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.211 138.075H319.187V146.77H327.211V138.075Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.241 138.075H329.217V146.77H337.241V138.075Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.211 156.19H319.187V164.885H327.211V156.19Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.241 156.19H329.217V164.885H337.241V156.19Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M259.007 156.19H250.983V164.885H259.007V156.19Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M276.392 156.19H268.368V164.885H276.392V156.19Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M293.777 156.19H285.753V164.885H293.777V156.19Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M259.007 195.318H250.983V204.013H259.007V195.318Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M276.392 195.318H268.368V204.013H276.392V195.318Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M293.777 195.318H285.753V204.013H293.777V195.318Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M259.007 234.445H250.983V243.14H259.007V234.445Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M276.392 234.445H268.368V243.14H276.392V234.445Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M293.777 234.445H285.753V243.14H293.777V234.445Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.211 174.305H319.187V183H327.211V174.305Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.241 174.305H329.217V183H337.241V174.305Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.211 192.419H319.187V201.114H327.211V192.419Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.241 192.419H329.217V201.114H337.241V192.419Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.211 210.534H319.187V219.229H327.211V210.534Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.241 210.534H329.217V219.229H337.241V210.534Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M353.957 192.419H345.933V201.114H353.957V192.419Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M372.68 192.419H364.656V201.114H372.68V192.419Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M353.957 209.809H345.933V218.504H353.957V209.809Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M372.68 209.809H364.656V218.504H372.68V209.809Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M353.957 227.199H345.933V235.894H353.957V227.199Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M372.68 227.199H364.656V235.894H372.68V227.199Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M353.957 244.59H345.933V253.285H353.957V244.59Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M372.68 244.59H364.656V253.285H372.68V244.59Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.211 228.649H319.187V237.344H327.211V228.649Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.241 228.649H329.217V237.344H337.241V228.649Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.211 246.763H319.187V255.458H327.211V246.763Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.241 246.763H329.217V255.458H337.241V246.763Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.59 233.721H72.566V242.416H80.59V233.721Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M63.873 251.835H55.849V260.53H63.873V251.835Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.59 251.835H72.566V260.53H80.59V251.835Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M63.873 269.95H55.849V278.645H63.873V269.95Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.59 269.95H72.566V278.645H80.59V269.95Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M63.873 288.065H55.849V296.76H63.873V288.065Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.59 288.065H72.566V296.76H80.59V288.065Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M301.802 293.508V329.366H234.934V258.086H301.802V287.128",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M369.846 329.366H357.97V291.688H371.769",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M133.391 291.688H180.89V329.366H114.023V291.688H127.05",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.771 291.688H35.12V329.366H10.38V291.688H23.789",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M273.718 258.086H263.019V329.366H273.718V258.086Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M190.609 267.776H180.104V248.937H215.543V267.776H200.12",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M343.609 306.567H207.204C202.966 306.567 199.53 303.131 199.53 298.893V27.595C199.53 23.357 202.966 19.921 207.204 19.921H343.609C347.848 19.921 351.283 23.357 351.283 27.595V298.892C351.284 303.131 347.848 306.567 343.609 306.567Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M344.539 51.396H206.275V275.092H344.539V51.396Z",
    fill: "#3FC7F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 206,
    y: 51,
    width: 139,
    height: 225
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M344.539 51.396H206.275V275.092H344.539V51.396Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.539 96.387L278.952 112.673L268.659 89.514L323.253 51.395H317.047L238.027 106.568C237.919 106.644 237.819 106.731 237.73 106.829L206.274 141.392V146.671L240.224 109.367L265.692 91.585L275.45 113.541L246.926 120.624L246.924 120.625L246.887 120.634C246.874 120.637 246.862 120.646 246.849 120.65C246.717 120.686 246.589 120.74 246.465 120.809C246.431 120.828 246.397 120.846 246.364 120.867C246.338 120.884 246.309 120.895 246.283 120.913C246.179 120.987 246.087 121.071 246.004 121.162C246.003 121.164 246.001 121.164 245.999 121.166L206.275 164.974V170.264L247.104 125.237C250.334 130.333 255.339 140.228 252.855 145.906C251.483 149.042 247.982 152.802 244.276 156.781C237.914 163.613 231.336 170.678 232.904 177.348C234.582 184.478 235.293 189.042 235.528 190.729L234.665 190.965C227.496 192.929 222.643 199.739 223.125 207.158L224.099 222.125L206.274 223.745V227.314L224.33 225.673L225.703 246.765C225.691 246.874 225.687 246.986 225.696 247.1C225.703 247.189 225.722 247.274 225.742 247.359L227.547 275.091H231.108L229.383 248.59L259.523 246.195L264 275.092H267.596L263.076 245.913L288.307 243.908L297.217 275.092H300.912L291.92 243.621L309.999 242.184C322.653 252.168 330.906 261.379 338.258 275.092H342.278C334.464 260.047 325.636 250.082 312.27 239.487C312.04 239.072 311.65 238.768 311.186 238.64C306.893 235.286 302.138 231.851 296.813 228.161L314.874 225.362C325.085 223.781 332.133 214.505 330.92 204.245L328.036 179.834C326.82 169.548 333.531 160.107 343.645 157.873L344.539 157.676V154.037L342.878 154.404C330.974 157.033 323.076 168.145 324.506 180.252L327.39 204.662C328.377 213.014 322.641 220.565 314.329 221.851L292.541 225.227C290.893 224.104 289.202 222.959 287.449 221.78C272.14 211.481 267.877 197.577 266.996 187.727C265.987 176.438 269.025 164.51 274.977 155.07C275.173 154.887 275.343 154.674 275.443 154.405C275.451 154.385 275.452 154.364 275.459 154.344C277.275 151.575 279.332 149.022 281.63 146.791C294.538 134.263 326.671 121.536 344.537 115.107V111.306C326.714 117.636 292.999 130.805 279.156 144.241C276.894 146.437 274.849 148.924 273.02 151.609L256.701 145.547C258.524 137.997 252.936 127.86 250.183 123.478L344.537 100.048V96.387H344.539ZM285.468 224.727C287.22 225.906 288.907 227.047 290.548 228.164C290.786 228.485 291.125 228.717 291.513 228.821C296.808 232.438 301.536 235.762 305.794 238.952L229.154 245.042L226.673 206.926C226.299 201.184 230.056 195.912 235.605 194.391L263.385 186.781C263.412 187.201 263.423 187.623 263.46 188.041C264.408 198.662 268.997 213.647 285.468 224.727ZM271.086 154.681C266.15 163.125 263.333 173.201 263.277 183.128L238.985 189.783C238.688 187.735 237.953 183.283 236.365 176.535C235.23 171.712 241.418 165.067 246.878 159.203C250.269 155.56 253.493 152.094 255.346 148.834L271.086 154.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.916 77.837L206.275 120.715V125.881L250.258 79.477C250.726 78.984 250.87 78.269 250.634 77.633L240.835 51.396H237.041L246.916 77.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.861 192.379C275.861 203.087 284.572 211.798 295.28 211.798C305.988 211.798 314.7 203.087 314.7 192.379C314.7 181.671 305.988 172.96 295.28 172.96C284.572 172.96 275.861 181.671 275.861 192.379ZM311.147 192.379C311.147 201.127 304.03 208.245 295.281 208.245C286.533 208.245 279.415 201.128 279.415 192.379C279.415 183.63 286.532 176.513 295.281 176.513C304.029 176.513 311.147 183.631 311.147 192.379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.903 87.76C304.533 91.835 308.5 94.401 312.733 94.401C313.584 94.401 314.447 94.297 315.303 94.08L344.538 86.691V83.026L314.432 90.635C311.036 91.492 307.5 89.688 306.202 86.44C304.973 83.37 306.083 79.816 308.839 77.989L344.538 54.323V51.396H342.521L306.875 75.027C302.724 77.779 301.053 83.134 302.903 87.76Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 206,
    y: 51,
    width: 139,
    height: 225
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M344.539 51.396H206.275V275.092H344.539V51.396Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.443 79.88C285.81 79.88 281.243 84.446 281.243 90.08C281.243 95.714 291.443 110.204 291.443 110.204C291.443 110.204 301.642 95.714 301.642 90.08C301.642 84.446 297.076 79.88 291.443 79.88ZM291.443 93.839C289.171 93.839 287.329 91.997 287.329 89.725C287.329 87.453 289.171 85.611 291.443 85.611C293.715 85.611 295.557 87.453 295.557 89.725C295.557 91.997 293.715 93.839 291.443 93.839Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.604 111.078L288.16 111.484",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.162 112.328L250.687 122.035",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.11 3.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.188 122.457L247.744 122.863C247.744 122.863 248.029 123.346 248.483 124.164",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.892 126.808C251.503 129.953 253.546 134.397 254.247 137.9C255.466 143.996 254.653 147.247 249.777 152.53C244.9 157.813 236.366 167.973 234.74 172.037C233.546 175.022 235.641 184.585 236.837 189.452",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.203 190.909C237.436 191.817 237.585 192.358 237.585 192.358",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.584 194.933C239.006 194.933 240.159 193.78 240.159 192.358C240.159 190.936 239.006 189.783 237.584 189.783C236.162 189.783 235.009 190.936 235.009 192.358C235.009 193.78 236.162 194.933 237.584 194.933Z",
    fill: "#3FC7F3",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.613 136.213V141.923L258.203 144.628L263.613 147.462V152.743H301.182V136.213H263.613Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.377 139.643C270.915 139.643 271.35 139.207 271.35 138.67C271.35 138.132 270.914 137.696 270.377 137.696C269.839 137.696 269.403 138.132 269.403 138.67C269.403 139.207 269.839 139.643 270.377 139.643Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.751 142.166L272.6 142.261C272.6 142.261 270.95 140.022 270.822 140.009C270.822 140.009 269.164 139.802 269.011 139.875L266.448 141.097C266.189 141.221 266.051 141.513 266.13 141.77L266.678 143.542C266.742 143.75 266.93 143.876 267.141 143.876C267.207 143.876 267.275 143.864 267.342 143.838C267.625 143.729 267.785 143.419 267.701 143.147L267.294 141.83L268.8 141.112L268.144 144.997L268.154 144.998L267.494 149.759C267.453 150.052 267.657 150.301 267.949 150.316C267.958 150.316 267.966 150.316 267.975 150.316C268.257 150.316 268.512 150.094 268.552 149.81L269.19 145.207L270.558 147.246L270.327 149.784C270.3 150.078 270.517 150.316 270.81 150.316C271.103 150.316 271.363 150.078 271.39 149.784L271.637 147.067C271.648 146.95 271.62 146.837 271.558 146.745L270.299 144.868L270.828 141.736L271.881 143.154C271.971 143.276 272.115 143.345 272.272 143.345C272.286 143.345 272.301 143.344 272.316 143.343L273.745 143.225C274.04 143.201 274.28 142.944 274.283 142.651C274.284 142.359 274.049 142.142 273.751 142.166Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.128 144.032C277.008 143.973 276.948 143.879 276.948 143.75C276.948 143.652 276.982 143.56 277.049 143.475C277.116 143.39 277.19 143.348 277.272 143.348C277.299 143.348 277.327 143.355 277.354 143.367C277.452 143.411 277.527 143.443 277.579 143.464C277.632 143.485 277.718 143.51 277.838 143.538C277.958 143.566 278.074 143.58 278.185 143.58C278.438 143.58 278.637 143.529 278.781 143.428C278.925 143.326 278.998 143.167 278.998 142.949C278.998 142.719 278.909 142.534 278.731 142.394C278.553 142.254 278.329 142.184 278.056 142.184H277.792C277.704 142.184 277.638 142.154 277.593 142.095C277.548 142.035 277.525 141.963 277.525 141.877C277.525 141.793 277.548 141.721 277.594 141.659C277.64 141.597 277.706 141.567 277.791 141.567H278.039C278.294 141.567 278.504 141.511 278.669 141.399C278.833 141.287 278.915 141.123 278.915 140.908C278.915 140.772 278.878 140.657 278.802 140.563C278.726 140.469 278.635 140.402 278.528 140.362C278.419 140.322 278.301 140.302 278.171 140.302C277.855 140.302 277.575 140.362 277.33 140.481C277.296 140.497 277.264 140.506 277.233 140.506C277.151 140.506 277.079 140.465 277.014 140.382C276.951 140.299 276.919 140.211 276.919 140.117C276.919 140.006 276.964 139.923 277.053 139.869C277.183 139.788 277.355 139.72 277.569 139.666C277.784 139.613 278.006 139.586 278.236 139.586C278.688 139.586 279.061 139.697 279.355 139.92C279.649 140.143 279.796 140.443 279.796 140.819C279.796 141.072 279.733 141.284 279.606 141.453C279.479 141.623 279.3 141.749 279.068 141.833C279.338 141.906 279.542 142.043 279.68 142.244C279.818 142.445 279.887 142.694 279.887 142.99C279.887 143.21 279.844 143.404 279.759 143.574C279.675 143.744 279.558 143.879 279.408 143.982C279.259 144.084 279.088 144.162 278.897 144.214C278.705 144.266 278.495 144.292 278.267 144.292C277.856 144.293 277.475 144.206 277.128 144.032Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.56 144.178C281.362 144.091 281.2 143.975 281.073 143.831C280.946 143.687 280.842 143.512 280.76 143.306C280.677 143.1 280.619 142.885 280.586 142.662C280.552 142.44 280.536 142.199 280.536 141.942C280.536 141.687 280.553 141.449 280.586 141.23C280.619 141.01 280.677 140.798 280.76 140.595C280.842 140.391 280.946 140.217 281.072 140.074C281.197 139.93 281.359 139.816 281.556 139.73C281.754 139.645 281.979 139.602 282.233 139.602C282.482 139.602 282.705 139.644 282.902 139.729C283.098 139.814 283.26 139.928 283.386 140.071C283.513 140.215 283.618 140.387 283.7 140.589C283.782 140.791 283.841 141.003 283.876 141.224C283.911 141.446 283.927 141.686 283.927 141.943C283.927 142.198 283.911 142.437 283.878 142.66C283.844 142.883 283.786 143.097 283.704 143.303C283.622 143.509 283.517 143.685 283.39 143.83C283.263 143.975 283.102 144.092 282.905 144.178C282.708 144.265 282.484 144.308 282.233 144.308C281.983 144.309 281.758 144.265 281.56 144.178ZM282.535 143.546C282.624 143.504 282.695 143.443 282.754 143.362C282.811 143.281 282.86 143.192 282.9 143.094C282.94 142.996 282.969 142.88 282.989 142.748C283.009 142.615 283.023 142.486 283.03 142.362C283.037 142.238 283.041 142.098 283.041 141.943C283.041 141.79 283.037 141.652 283.03 141.529C283.023 141.405 283.009 141.278 282.989 141.146C282.969 141.014 282.94 140.901 282.901 140.804C282.862 140.708 282.814 140.62 282.756 140.54C282.699 140.461 282.626 140.4 282.536 140.359C282.447 140.318 282.346 140.298 282.233 140.298C282.12 140.298 282.019 140.318 281.93 140.359C281.841 140.4 281.768 140.46 281.711 140.54C281.653 140.619 281.605 140.707 281.566 140.804C281.528 140.9 281.498 141.014 281.478 141.146C281.458 141.278 281.444 141.405 281.437 141.527C281.43 141.65 281.426 141.788 281.426 141.943C281.426 142.098 281.43 142.237 281.437 142.36C281.444 142.484 281.458 142.612 281.478 142.746C281.498 142.88 281.527 142.996 281.566 143.094C281.605 143.192 281.653 143.282 281.711 143.362C281.768 143.443 281.841 143.504 281.93 143.546C282.019 143.588 282.12 143.609 282.233 143.609C282.346 143.609 282.447 143.588 282.535 143.546Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.508 144.114C286.434 144.038 286.398 143.932 286.398 143.794V141.5C286.398 141.366 286.434 141.263 286.508 141.189C286.581 141.116 286.676 141.079 286.793 141.079C286.904 141.079 286.998 141.112 287.074 141.178C287.15 141.244 287.189 141.335 287.189 141.453V141.61C287.383 141.229 287.719 141.039 288.196 141.039C288.457 141.039 288.677 141.1 288.855 141.223C289.033 141.345 289.155 141.513 289.222 141.727C289.416 141.269 289.785 141.039 290.326 141.039C290.67 141.039 290.945 141.14 291.155 141.34C291.364 141.541 291.469 141.838 291.469 142.231V143.794C291.469 143.932 291.432 144.039 291.357 144.114C291.283 144.189 291.188 144.227 291.07 144.227C290.957 144.227 290.864 144.189 290.792 144.114C290.718 144.038 290.682 143.932 290.682 143.794V142.237C290.682 142.02 290.63 141.854 290.525 141.741C290.42 141.628 290.276 141.571 290.092 141.571C289.865 141.571 289.682 141.652 289.539 141.816C289.397 141.979 289.325 142.204 289.325 142.49V143.793C289.325 143.929 289.288 144.035 289.214 144.111C289.139 144.187 289.044 144.226 288.927 144.226C288.816 144.226 288.723 144.188 288.649 144.111C288.574 144.035 288.537 143.928 288.537 143.793V142.255C288.537 142.029 288.486 141.859 288.382 141.744C288.279 141.629 288.134 141.571 287.947 141.571C287.717 141.571 287.533 141.646 287.394 141.797C287.256 141.948 287.188 142.153 287.188 142.412V143.793C287.188 143.931 287.15 144.038 287.073 144.113C286.997 144.188 286.9 144.226 286.782 144.226C286.673 144.227 286.581 144.189 286.508 144.114Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.363 140.331C292.278 140.25 292.235 140.145 292.235 140.016C292.235 139.887 292.278 139.782 292.363 139.702C292.447 139.623 292.559 139.583 292.697 139.583C292.833 139.583 292.942 139.623 293.027 139.702C293.11 139.782 293.153 139.886 293.153 140.016C293.153 140.146 293.111 140.251 293.025 140.331C292.94 140.412 292.83 140.452 292.694 140.452C292.558 140.451 292.447 140.411 292.363 140.331ZM292.411 144.112C292.337 144.036 292.301 143.927 292.301 143.787V141.521C292.301 141.38 292.337 141.272 292.411 141.194C292.484 141.117 292.578 141.078 292.693 141.078C292.808 141.078 292.903 141.117 292.978 141.194C293.052 141.272 293.089 141.38 293.089 141.521V143.787C293.089 143.925 293.052 144.033 292.978 144.11C292.903 144.188 292.809 144.226 292.693 144.226C292.579 144.227 292.484 144.189 292.411 144.112Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.996 144.112C293.923 144.036 293.887 143.929 293.887 143.794V141.475C293.887 141.35 293.924 141.252 294 141.183C294.076 141.114 294.17 141.079 294.285 141.079C294.398 141.079 294.491 141.113 294.564 141.181C294.637 141.249 294.673 141.344 294.673 141.468V141.578C294.766 141.4 294.899 141.265 295.076 141.173C295.253 141.081 295.464 141.035 295.708 141.035C295.859 141.035 296 141.06 296.133 141.109C296.267 141.158 296.384 141.231 296.49 141.326C296.595 141.421 296.677 141.547 296.738 141.704C296.799 141.861 296.829 142.04 296.829 142.241V143.795C296.829 143.931 296.791 144.037 296.715 144.113C296.64 144.189 296.544 144.228 296.427 144.228C296.316 144.228 296.224 144.19 296.15 144.113C296.077 144.037 296.041 143.93 296.041 143.795V142.238C296.041 142.023 295.985 141.858 295.873 141.744C295.761 141.63 295.619 141.573 295.444 141.573C295.235 141.573 295.055 141.656 294.902 141.821C294.748 141.986 294.672 142.202 294.672 142.467V143.795C294.672 143.931 294.636 144.037 294.561 144.113C294.486 144.189 294.392 144.228 294.277 144.228C294.163 144.227 294.069 144.189 293.996 144.112Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.871 144.111C297.786 144.026 297.743 143.921 297.743 143.797C297.743 143.678 297.786 143.574 297.871 143.488C297.955 143.401 298.064 143.358 298.195 143.358C298.321 143.358 298.427 143.4 298.515 143.483C298.603 143.567 298.647 143.671 298.647 143.797C298.647 143.918 298.604 144.022 298.519 144.109C298.433 144.196 298.326 144.239 298.195 144.239C298.064 144.24 297.957 144.197 297.871 144.111Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.067 149.171L277.74 150.348H279.479C279.565 150.348 279.632 150.381 279.68 150.447C279.728 150.513 279.752 150.592 279.752 150.684C279.752 150.776 279.728 150.856 279.68 150.924C279.631 150.992 279.565 151.026 279.479 151.026H277.244C277.106 151.026 276.997 150.983 276.916 150.897C276.835 150.812 276.795 150.708 276.795 150.586C276.795 150.433 276.852 150.299 276.968 150.184L278.594 148.568C278.859 148.309 278.992 148.063 278.992 147.83C278.992 147.635 278.923 147.476 278.784 147.353C278.644 147.23 278.476 147.168 278.277 147.168C278.159 147.168 278.048 147.181 277.942 147.206C277.836 147.231 277.761 147.254 277.715 147.274C277.669 147.294 277.594 147.334 277.489 147.395C277.384 147.456 277.323 147.49 277.307 147.499C277.279 147.514 277.249 147.521 277.216 147.521C277.13 147.521 277.049 147.48 276.974 147.398C276.898 147.317 276.861 147.229 276.861 147.135C276.861 147.026 276.916 146.939 277.024 146.874C277.233 146.751 277.444 146.655 277.655 146.587C277.867 146.519 278.101 146.485 278.359 146.485C278.786 146.485 279.135 146.611 279.409 146.861C279.681 147.112 279.819 147.42 279.819 147.784C279.817 148.272 279.567 148.734 279.067 149.171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.644 150.91C282.571 150.833 282.536 150.724 282.536 150.584V146.943C282.536 146.803 282.572 146.694 282.645 146.617C282.719 146.54 282.812 146.501 282.928 146.501C283.043 146.501 283.138 146.54 283.212 146.617C283.287 146.694 283.324 146.803 283.324 146.943V149.24L284.623 147.947C284.69 147.874 284.766 147.837 284.852 147.837C284.941 147.837 285.019 147.874 285.088 147.948C285.157 148.022 285.191 148.107 285.191 148.201C285.191 148.285 285.161 148.357 285.103 148.417L284.155 149.327L285.238 150.456C285.301 150.525 285.333 150.601 285.333 150.682C285.333 150.776 285.296 150.858 285.221 150.928C285.147 150.998 285.062 151.033 284.966 151.033C284.859 151.033 284.768 150.989 284.693 150.901L283.325 149.445V150.581C283.325 150.721 283.287 150.83 283.211 150.907C283.136 150.985 283.04 151.023 282.923 151.023C282.808 151.026 282.716 150.988 282.644 150.91Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.959 150.913C285.885 150.837 285.849 150.731 285.849 150.593V148.299C285.849 148.165 285.885 148.062 285.959 147.988C286.032 147.915 286.127 147.878 286.244 147.878C286.355 147.878 286.449 147.911 286.525 147.977C286.601 148.043 286.64 148.134 286.64 148.252V148.409C286.834 148.028 287.17 147.838 287.647 147.838C287.908 147.838 288.128 147.899 288.306 148.022C288.484 148.144 288.606 148.312 288.673 148.526C288.867 148.068 289.236 147.838 289.777 147.838C290.121 147.838 290.396 147.939 290.606 148.139C290.815 148.34 290.92 148.637 290.92 149.03V150.593C290.92 150.731 290.883 150.838 290.808 150.913C290.734 150.988 290.639 151.026 290.521 151.026C290.408 151.026 290.315 150.988 290.242 150.913C290.168 150.837 290.132 150.731 290.132 150.593V149.036C290.132 148.819 290.08 148.653 289.975 148.54C289.87 148.427 289.726 148.37 289.542 148.37C289.316 148.37 289.132 148.451 288.989 148.615C288.847 148.778 288.776 149.003 288.776 149.289V150.592C288.776 150.728 288.739 150.834 288.665 150.91C288.59 150.986 288.495 151.025 288.378 151.025C288.267 151.025 288.174 150.987 288.1 150.91C288.025 150.834 287.988 150.727 287.988 150.592V149.054C287.988 148.828 287.937 148.658 287.833 148.543C287.73 148.428 287.585 148.37 287.398 148.37C287.168 148.37 286.984 148.445 286.845 148.596C286.707 148.747 286.639 148.952 286.639 149.211V150.592C286.639 150.73 286.601 150.837 286.524 150.912C286.448 150.987 286.35 151.025 286.233 151.025C286.123 151.026 286.031 150.988 285.959 150.913Z",
    fill: "black"
  })))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M344.539 51.396H206.275V275.092H344.539V51.396Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M290.437 35.739H260.376C259.244 35.739 258.327 34.822 258.327 33.689C258.327 32.557 259.244 31.639 260.376 31.639H290.437C291.569 31.639 292.487 32.557 292.487 33.689C292.487 34.822 291.569 35.739 290.437 35.739Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M283.605 287.723C283.605 283.195 279.934 279.525 275.406 279.525C270.879 279.525 267.208 283.196 267.208 287.723C267.208 292.251 270.878 295.921 275.406 295.921C279.934 295.921 283.605 292.251 283.605 287.723Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 0.7043,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M279.561 283.567H271.251V291.878H279.561V283.567Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M59.93 176.029L84.983 98.485L89.159 96.298L63.907 176.427L59.93 176.029Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M142.379 316.669C142.379 316.669 149.537 318.525 152.983 318.79C156.429 319.055 161.466 318.26 161.997 319.85C162.527 321.441 156.165 325.152 151.923 326.743C147.681 328.334 143.174 328.069 139.198 328.864C135.221 329.659 132.04 329.394 131.245 328.864C130.45 328.334 131.245 321.441 131.245 321.441L142.379 316.669Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 316,
    width: 33,
    height: 14
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M142.379 316.669C142.379 316.669 149.537 318.525 152.983 318.79C156.429 319.055 161.466 318.26 161.997 319.85C162.527 321.441 156.165 325.152 151.923 326.743C147.681 328.334 143.174 328.069 139.198 328.864C135.221 329.659 132.04 329.394 131.245 328.864C130.45 328.334 131.245 321.441 131.245 321.441L142.379 316.669Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.005 319.978C161.358 320.057 160.647 320.283 159.935 320.775C157.575 322.409 157.938 324.043 146.863 324.043C135.788 324.043 138.148 323.498 138.148 322.046C138.148 321.078 139.999 318.664 141.236 317.158L131.244 321.44C131.244 321.44 130.449 328.333 131.244 328.863C132.039 329.393 135.221 329.658 139.197 328.863C143.174 328.068 147.681 328.333 151.922 326.742C156.06 325.192 162.195 321.629 162.005 319.978Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 316,
    width: 33,
    height: 14
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M142.379 316.669C142.379 316.669 149.537 318.525 152.983 318.79C156.429 319.055 161.466 318.26 161.997 319.85C162.527 321.441 156.165 325.152 151.923 326.743C147.681 328.334 143.174 328.069 139.198 328.864C135.221 329.659 132.04 329.394 131.245 328.864C130.45 328.334 131.245 321.441 131.245 321.441L142.379 316.669Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.887 326.949C130.887 326.949 136.152 327.857 143.414 326.586C150.676 325.315 159.028 319.869 161.388 319.505",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M142.379 316.669C142.379 316.669 149.537 318.525 152.983 318.79C156.429 319.055 161.466 318.26 161.997 319.85C162.527 321.441 156.165 325.152 151.923 326.743C147.681 328.334 143.174 328.069 139.198 328.864C135.221 329.659 132.04 329.394 131.245 328.864C130.45 328.334 131.245 321.441 131.245 321.441L142.379 316.669Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M69.474 313.223C69.474 313.223 66.558 317.73 64.967 318.79C63.376 319.85 59.4 323.032 58.604 325.683C57.809 328.334 61.52 329.395 64.701 329.129C67.882 328.863 71.594 329.129 73.45 326.213C75.306 323.297 78.752 314.283 78.752 314.283C78.752 314.283 71.86 311.897 69.474 313.223Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 312,
    width: 21,
    height: 18
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M69.474 313.223C69.474 313.223 66.558 317.73 64.967 318.79C63.376 319.85 59.4 323.032 58.604 325.683C57.809 328.334 61.52 329.395 64.701 329.129C67.882 328.863 71.594 329.129 73.45 326.213C75.306 323.297 78.752 314.283 78.752 314.283C78.752 314.283 71.86 311.897 69.474 313.223Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M74.79 323.696C74.322 323.858 73.838 324.032 73.335 324.226C68.615 326.042 67.162 323.863 66.436 322.955C65.855 322.229 73.404 316.045 76.448 313.599C74.219 313.016 70.966 312.395 69.475 313.223C69.475 313.223 66.559 317.73 64.968 318.79C63.377 319.85 59.401 323.032 58.605 325.683C57.81 328.334 61.521 329.395 64.702 329.129C67.883 328.863 71.595 329.129 73.45 326.213C73.842 325.598 74.304 324.711 74.79 323.696Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 312,
    width: 21,
    height: 18
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M69.474 313.223C69.474 313.223 66.558 317.73 64.967 318.79C63.376 319.85 59.4 323.032 58.604 325.683C57.809 328.334 61.52 329.395 64.701 329.129C67.882 328.863 71.594 329.129 73.45 326.213C75.306 323.297 78.752 314.283 78.752 314.283C78.752 314.283 71.86 311.897 69.474 313.223Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.605 325.683C58.605 325.683 62.623 328.22 68.433 327.13C74.243 326.041 74.969 323.136 74.969 323.136",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M69.474 313.223C69.474 313.223 66.558 317.73 64.967 318.79C63.376 319.85 59.4 323.032 58.604 325.683C57.809 328.334 61.52 329.395 64.701 329.129C67.882 328.863 71.594 329.129 73.45 326.213C75.306 323.297 78.752 314.283 78.752 314.283C78.752 314.283 71.86 311.897 69.474 313.223Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M80.874 201.612C80.874 201.612 81.669 233.955 81.404 235.016C81.139 236.077 78.488 246.681 77.692 250.392C76.897 254.104 73.981 264.443 74.246 275.312C74.511 286.181 71.065 302.883 71.065 302.883C71.065 302.883 68.944 307.39 69.209 308.45C69.474 309.51 69.474 313.222 69.474 313.222C69.474 313.222 73.981 313.752 76.897 314.282C79.813 314.812 79.813 312.161 79.813 312.161C79.813 312.161 82.464 308.715 82.729 306.063C82.994 303.412 85.778 295.724 85.778 295.724C85.778 295.724 95.455 266.032 97.045 262.32C98.636 258.609 101.552 246.148 103.143 241.376C104.734 236.604 110.566 211.154 110.566 211.154C110.566 211.154 119.845 252.776 119.845 256.487C119.845 260.199 118.254 272.129 120.11 279.817C121.966 287.505 128.859 308.714 128.859 308.714C128.859 308.714 127.533 314.546 127.533 315.607C127.533 316.668 131.245 321.439 131.245 321.439L142.38 316.667C142.38 316.667 142.115 308.449 142.115 306.593C142.115 304.737 143.441 298.905 142.91 296.519C142.38 294.133 138.403 291.217 138.403 288.831C138.403 286.445 141.584 258.874 141.319 248.8C141.054 238.726 136.812 198.695 134.956 193.922C133.1 189.15 121.435 176.69 116.664 176.16C111.892 175.631 80.874 201.612 80.874 201.612Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M121.86 254.069C121.86 254.069 126.667 244.856 131.073 237.245",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M134.277 234.04L135.479 231.237",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M91.015 275.7C91.015 275.7 85.407 285.472 75.393 290.922",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M86.208 292.525C86.208 292.525 80.6 296.13 77.796 297.332",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M183.886 103.932L174.346 122.695L181.291 126.93L193.11 103.132C193.419 102.509 192.918 101.79 192.226 101.865L185.876 102.558C185.023 102.651 184.275 103.167 183.886 103.932Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M174.176 141.666C174.176 141.666 185.525 129.301 186.541 128.115C187.557 126.929 188.235 118.629 188.235 117.782C188.235 116.935 183.661 109.651 183.661 109.651L182.136 110.498L186.879 118.798L178.918 111.853L177.902 113.039L184.678 120.661L183.831 123.879L176.547 115.24L175.192 116.595L181.459 125.742L175.022 121.338L174.344 122.693L178.579 128.622C178.579 128.622 174.852 129.469 174.175 131.502C173.497 133.535 174.006 134.89 174.006 134.89L171.126 137.431L174.176 141.666Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 109,
    width: 18,
    height: 33
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M174.176 141.666C174.176 141.666 185.525 129.301 186.541 128.115C187.557 126.929 188.235 118.629 188.235 117.782C188.235 116.935 183.661 109.651 183.661 109.651L182.136 110.498L186.879 118.798L178.918 111.853L177.902 113.039L184.678 120.661L183.831 123.879L176.547 115.24L175.192 116.595L181.459 125.742L175.022 121.338L174.344 122.693L178.579 128.622C178.579 128.622 174.852 129.469 174.175 131.502C173.497 133.535 174.006 134.89 174.006 134.89L171.126 137.431L174.176 141.666Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.176 141.666C174.176 141.666 185.525 129.301 186.541 128.115C187.557 126.929 188.235 118.629 188.235 117.782C188.235 116.935 183.661 109.651 183.661 109.651L182.136 110.498L186.879 118.798L178.918 111.853L177.902 113.039L184.678 120.661L183.831 123.879L176.547 115.24L175.192 116.595L181.459 125.742L175.022 121.338L174.344 122.693L178.579 128.622C178.579 128.622 174.852 129.469 174.175 131.502C173.497 133.535 174.006 134.89 174.006 134.89L171.126 137.431L174.176 141.666Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 109,
    width: 18,
    height: 33
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M174.176 141.666C174.176 141.666 185.525 129.301 186.541 128.115C187.557 126.929 188.235 118.629 188.235 117.782C188.235 116.935 183.661 109.651 183.661 109.651L182.136 110.498L186.879 118.798L178.918 111.853L177.902 113.039L184.678 120.661L183.831 123.879L176.547 115.24L175.192 116.595L181.459 125.742L175.022 121.338L174.344 122.693L178.579 128.622C178.579 128.622 174.852 129.469 174.175 131.502C173.497 133.535 174.006 134.89 174.006 134.89L171.126 137.431L174.176 141.666Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.573 128.625C178.491 128.644 174.846 129.493 174.177 131.503C173.499 133.536 174.008 134.891 174.008 134.891L171.128 137.432L174.177 141.667C174.177 141.667 185.526 129.302 186.542 128.116C186.783 127.835 187.004 127.146 187.203 126.259C185.902 127.002 180.598 129.43 180.014 129.43C179.693 129.429 179.091 129.025 178.573 128.625Z",
    fill: "black"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M174.176 141.666C174.176 141.666 185.525 129.301 186.541 128.115C187.557 126.929 188.235 118.629 188.235 117.782C188.235 116.935 183.661 109.651 183.661 109.651L182.136 110.498L186.879 118.798L178.918 111.853L177.902 113.039L184.678 120.661L183.831 123.879L176.547 115.24L175.192 116.595L181.459 125.742L175.022 121.338L174.344 122.693L178.579 128.622C178.579 128.622 174.852 129.469 174.175 131.502C173.497 133.535 174.006 134.89 174.006 134.89L171.126 137.431L174.176 141.666Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M183.831 123.88L184.001 126.59",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M186.88 118.799L187.05 121.848",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M181.46 125.743L181.291 126.929",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M175.531 142.852L177.733 139.803L174.007 134.89L171.297 136.584L175.531 142.852Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M171.805 135.907L177.564 144.207C177.564 144.207 157.083 160.844 153.356 162.876C149.629 164.909 148.274 165.756 147.766 165.925C147.258 166.094 135.545 144.879 132.835 138.781C130.125 132.683 141.584 104.582 141.584 104.582C141.584 104.582 149.095 124.825 151.128 131.093C153.161 137.36 156.575 143.058 156.575 143.058L171.805 135.907Z",
    fill: "#3FC7F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 104,
    width: 46,
    height: 62
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M171.805 135.907L177.564 144.207C177.564 144.207 157.083 160.844 153.356 162.876C149.629 164.909 148.274 165.756 147.766 165.925C147.258 166.094 135.545 144.879 132.835 138.781C130.125 132.683 141.584 104.582 141.584 104.582C141.584 104.582 149.095 124.825 151.128 131.093C153.161 137.36 156.575 143.058 156.575 143.058L171.805 135.907Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M175.072 146.221C169.11 146.643 157.971 147.184 155.274 147.184C151.738 147.184 146.526 151.093 146.526 151.093C146.526 151.093 144.665 151.837 143.734 149.976C142.803 148.115 145.037 144.206 145.037 144.206C145.037 144.206 142.059 143.461 140.942 142.345C139.825 141.228 138.15 116.472 138.15 116.472L137.081 116.73C134.223 125.129 131.324 135.378 132.836 138.78C135.546 144.878 147.259 166.093 147.767 165.924C148.275 165.755 149.63 164.908 153.357 162.875C156.278 161.282 169.498 150.712 175.072 146.221Z",
    fill: "black"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M171.805 135.907L177.564 144.207C177.564 144.207 157.083 160.844 153.356 162.876C149.629 164.909 148.274 165.756 147.766 165.925C147.258 166.094 135.545 144.879 132.835 138.781C130.125 132.683 141.584 104.582 141.584 104.582C141.584 104.582 149.095 124.825 151.128 131.093C153.161 137.36 156.575 143.058 156.575 143.058L171.805 135.907Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M156.84 142.793C156.84 142.793 148.709 146.181 147.354 148.213C145.999 150.246 145.829 153.295 145.829 153.295",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M133.548 143.453C133.548 143.453 134.16 139.577 135.486 136.926C136.812 134.275 140.258 111.476 141.584 107.764C141.905 106.865 141.958 106.062 141.86 105.358C141.679 104.727 141.425 104.131 141.029 103.56C139.533 101.399 130.889 94.584 127.897 92.423C124.905 90.262 119.918 88.267 116.926 88.267C113.934 88.267 107.617 88.433 107.617 88.433C107.617 88.433 100.635 91.757 97.311 92.755C93.986 93.752 79.359 100.235 79.359 101.399C79.359 102.563 82.351 163.235 82.351 163.235L79.691 204.459C79.691 204.459 91.826 199.971 99.638 195.815C107.451 191.659 117.258 180.688 117.258 180.688C117.258 180.688 124.572 187.669 127.73 189.997C130.888 192.324 138.867 201.3 138.867 201.3L132.384 155.421L133.548 143.453Z",
    fill: "#3FC7F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 88,
    width: 63,
    height: 117
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M133.548 143.453C133.548 143.453 134.16 139.577 135.486 136.926C136.812 134.275 140.258 111.476 141.584 107.764C141.905 106.865 141.958 106.062 141.86 105.358C141.679 104.727 141.425 104.131 141.029 103.56C139.533 101.399 130.889 94.584 127.897 92.423C124.905 90.262 119.918 88.267 116.926 88.267C113.934 88.267 107.617 88.433 107.617 88.433C107.617 88.433 100.635 91.757 97.311 92.755C93.986 93.752 79.359 100.235 79.359 101.399C79.359 102.563 82.351 163.235 82.351 163.235L79.691 204.459C79.691 204.459 91.826 199.971 99.638 195.815C107.451 191.659 117.258 180.688 117.258 180.688C117.258 180.688 124.572 187.669 127.73 189.997C130.888 192.324 138.867 201.3 138.867 201.3L132.384 155.421L133.548 143.453Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.795 92.049C101.795 92.049 96.969 109.422 98.9 116.822C100.83 124.222 109.517 136.447 109.517 136.447",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 88,
    width: 63,
    height: 117
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M133.548 143.453C133.548 143.453 134.16 139.577 135.486 136.926C136.812 134.275 140.258 111.476 141.584 107.764C141.905 106.865 141.958 106.062 141.86 105.358C141.679 104.727 141.425 104.131 141.029 103.56C139.533 101.399 130.889 94.584 127.897 92.423C124.905 90.262 119.918 88.267 116.926 88.267C113.934 88.267 107.617 88.433 107.617 88.433C107.617 88.433 100.635 91.757 97.311 92.755C93.986 93.752 79.359 100.235 79.359 101.399C79.359 102.563 82.351 163.235 82.351 163.235L79.691 204.459C79.691 204.459 91.826 199.971 99.638 195.815C107.451 191.659 117.258 180.688 117.258 180.688C117.258 180.688 124.572 187.669 127.73 189.997C130.888 192.324 138.867 201.3 138.867 201.3L132.384 155.421L133.548 143.453Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.637 91.084C124.637 91.084 136.219 111.031 135.254 119.396C134.289 127.761 125.924 137.091 125.924 137.091",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 88,
    width: 63,
    height: 117
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M133.548 143.453C133.548 143.453 134.16 139.577 135.486 136.926C136.812 134.275 140.258 111.476 141.584 107.764C141.905 106.865 141.958 106.062 141.86 105.358C141.679 104.727 141.425 104.131 141.029 103.56C139.533 101.399 130.889 94.584 127.897 92.423C124.905 90.262 119.918 88.267 116.926 88.267C113.934 88.267 107.617 88.433 107.617 88.433C107.617 88.433 100.635 91.757 97.311 92.755C93.986 93.752 79.359 100.235 79.359 101.399C79.359 102.563 82.351 163.235 82.351 163.235L79.691 204.459C79.691 204.459 91.826 199.971 99.638 195.815C107.451 191.659 117.258 180.688 117.258 180.688C117.258 180.688 124.572 187.669 127.73 189.997C130.888 192.324 138.867 201.3 138.867 201.3L132.384 155.421L133.548 143.453Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M136.288 135.272C136.288 135.272 114.511 149.604 113.58 150.163C112.649 150.721 89.755 143.834 92.361 145.323C94.967 146.812 116.186 157.98 116.186 157.98L129.588 154.071L133.311 160.4L132.38 153.327L136.288 135.272Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 88,
    width: 63,
    height: 117
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M133.548 143.453C133.548 143.453 134.16 139.577 135.486 136.926C136.812 134.275 140.258 111.476 141.584 107.764C141.905 106.865 141.958 106.062 141.86 105.358C141.679 104.727 141.425 104.131 141.029 103.56C139.533 101.399 130.889 94.584 127.897 92.423C124.905 90.262 119.918 88.267 116.926 88.267C113.934 88.267 107.617 88.433 107.617 88.433C107.617 88.433 100.635 91.757 97.311 92.755C93.986 93.752 79.359 100.235 79.359 101.399C79.359 102.563 82.351 163.235 82.351 163.235L79.691 204.459C79.691 204.459 91.826 199.971 99.638 195.815C107.451 191.659 117.258 180.688 117.258 180.688C117.258 180.688 124.572 187.669 127.73 189.997C130.888 192.324 138.867 201.3 138.867 201.3L132.384 155.421L133.548 143.453Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.846 181.247C87.335 180.13 88.824 171.01 88.638 168.776C88.452 166.542 88.638 137.506 89.01 133.783C89.382 130.06 84.543 143.834 84.543 143.834L86.032 127.082L81.095 137.662C81.755 151.148 82.351 163.234 82.351 163.234L81.116 182.379C83.368 182.053 85.291 181.663 85.846 181.247Z",
    fill: "black"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M133.548 143.453C133.548 143.453 134.16 139.577 135.486 136.926C136.812 134.275 140.258 111.476 141.584 107.764C141.905 106.865 141.958 106.062 141.86 105.358C141.679 104.727 141.425 104.131 141.029 103.56C139.533 101.399 130.889 94.584 127.897 92.423C124.905 90.262 119.918 88.267 116.926 88.267C113.934 88.267 107.617 88.433 107.617 88.433C107.617 88.433 100.635 91.757 97.311 92.755C93.986 93.752 79.359 100.235 79.359 101.399C79.359 102.563 82.351 163.235 82.351 163.235L79.691 204.459C79.691 204.459 91.826 199.971 99.638 195.815C107.451 191.659 117.258 180.688 117.258 180.688C117.258 180.688 124.572 187.669 127.73 189.997C130.888 192.324 138.867 201.3 138.867 201.3L132.384 155.421L133.548 143.453Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M115.782 152.873C115.782 152.873 116.348 167.722 116.664 176.161",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M118.644 155.1C118.644 155.646 118.322 156.089 117.925 156.089C117.528 156.089 117.206 155.646 117.206 155.1C117.206 154.554 117.528 154.111 117.925 154.111C118.322 154.111 118.644 154.554 118.644 155.1Z",
    fill: "#263238"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M119.003 164.09C119.003 164.636 118.681 165.079 118.284 165.079C117.887 165.079 117.565 164.636 117.565 164.09C117.565 163.544 117.887 163.101 118.284 163.101C118.681 163.101 119.003 163.544 119.003 164.09Z",
    fill: "#263238"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M119.902 174.338C119.902 174.884 119.58 175.327 119.183 175.327C118.786 175.327 118.464 174.884 118.464 174.338C118.464 173.792 118.786 173.349 119.183 173.349C119.58 173.349 119.902 173.792 119.902 174.338Z",
    fill: "#263238"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M104.563 66.803C104.563 66.803 102.729 64.468 101.728 66.636C100.727 68.804 100.727 72.806 101.395 74.473C102.062 76.14 104.063 77.308 104.23 76.307C104.396 75.307 104.563 66.803 104.563 66.803Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 65,
    width: 5,
    height: 12
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M104.563 66.803C104.563 66.803 102.729 64.468 101.728 66.636C100.727 68.804 100.727 72.806 101.395 74.473C102.062 76.14 104.063 77.308 104.23 76.307C104.396 75.307 104.563 66.803 104.563 66.803Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.563 66.803C104.563 66.803 102.729 64.468 101.728 66.636C100.727 68.804 100.727 72.806 101.395 74.473C102.062 76.14 104.063 77.308 104.23 76.307C104.396 75.307 104.563 66.803 104.563 66.803Z",
    fill: "black"
  }))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M104.563 66.803C104.563 66.803 102.729 64.468 101.728 66.636C100.727 68.804 100.727 72.806 101.395 74.473C102.062 76.14 104.063 77.308 104.23 76.307C104.396 75.307 104.563 66.803 104.563 66.803Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M106.121 89.097C106.121 89.097 105.955 100.4 106.454 109.543C106.953 118.685 105.623 125.501 107.95 130.321C110.277 135.141 115.763 150.601 116.428 149.603C117.093 148.606 127.565 131.152 128.895 125.168C130.225 119.184 127.233 100.733 125.571 96.91C123.909 93.087 123.41 89.762 121.415 88.765C119.419 87.767 110.277 83.445 106.121 89.097Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M105.789 88.1C105.789 88.1 105.955 91.591 107.784 94.417C109.613 97.243 115.43 106.053 116.76 105.554C118.09 105.055 121.581 94.749 122.578 91.092C123.575 87.435 124.739 81.118 124.739 81.118C124.739 81.118 120.251 86.271 117.093 87.435C113.934 88.598 105.789 88.1 105.789 88.1Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M105.789 88.1C105.789 88.1 105.955 91.591 107.784 94.417C109.613 97.243 115.43 106.053 116.76 105.554C118.09 105.055 121.581 94.749 122.578 91.092C123.575 87.435 124.739 81.118 124.739 81.118C124.739 81.118 120.251 86.271 117.093 87.435C113.934 88.598 105.789 88.1 105.789 88.1Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M117.698 93.319C121.212 89.638 124.056 83.28 124.056 83.28L123.118 82.843C121.524 84.453 119.052 86.712 117.091 87.435C113.933 88.599 105.788 88.1 105.788 88.1C105.788 88.1 105.954 91.591 107.783 94.417C108.469 95.478 109.718 97.382 111.08 99.32C112.864 97.861 115.558 95.561 117.698 93.319Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M128.728 71.145L128.708 71.168C130.193 67.193 132.052 61.739 132.052 59.343C132.052 55.353 127.398 49.037 120.749 48.372C114.1 47.707 108.282 52.528 106.454 56.351C104.625 60.174 102.298 77.96 102.298 81.451C102.298 84.942 104.791 91.258 111.108 91.425C117.425 91.591 121.082 87.768 121.913 86.438C122.744 85.108 125.404 80.786 125.404 80.786C126.567 80.62 129.726 79.29 129.726 79.29C132.219 78.126 131.887 74.469 131.887 71.81C131.886 69.15 128.728 71.145 128.728 71.145Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 48,
    width: 31,
    height: 44
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M128.728 71.145L128.708 71.168C130.193 67.193 132.052 61.739 132.052 59.343C132.052 55.353 127.398 49.037 120.749 48.372C114.1 47.707 108.282 52.528 106.454 56.351C104.625 60.174 102.298 77.96 102.298 81.451C102.298 84.942 104.791 91.258 111.108 91.425C117.425 91.591 121.082 87.768 121.913 86.438C122.744 85.108 125.404 80.786 125.404 80.786C126.567 80.62 129.726 79.29 129.726 79.29C132.219 78.126 131.887 74.469 131.887 71.81C131.886 69.15 128.728 71.145 128.728 71.145Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M128.728 71.145L128.708 71.168C130.193 67.193 132.052 61.739 132.052 59.343C132.052 55.353 127.398 49.037 120.749 48.372C114.1 47.707 108.282 52.528 106.454 56.351C104.625 60.174 102.298 77.96 102.298 81.451C102.298 84.942 104.791 91.258 111.108 91.425C117.425 91.591 121.082 87.768 121.913 86.438C122.744 85.108 125.404 80.786 125.404 80.786C126.567 80.62 129.726 79.29 129.726 79.29C132.219 78.126 131.887 74.469 131.887 71.81C131.886 69.15 128.728 71.145 128.728 71.145Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 48,
    width: 31,
    height: 44
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M128.728 71.145L128.708 71.168C130.193 67.193 132.052 61.739 132.052 59.343C132.052 55.353 127.398 49.037 120.749 48.372C114.1 47.707 108.282 52.528 106.454 56.351C104.625 60.174 102.298 77.96 102.298 81.451C102.298 84.942 104.791 91.258 111.108 91.425C117.425 91.591 121.082 87.768 121.913 86.438C122.744 85.108 125.404 80.786 125.404 80.786C126.567 80.62 129.726 79.29 129.726 79.29C132.219 78.126 131.887 74.469 131.887 71.81C131.886 69.15 128.728 71.145 128.728 71.145Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.663 64.038C109.165 62.867 108.998 57.847 113.85 52.995C116.703 50.142 120.357 49.145 122.891 48.804C122.203 48.6 121.49 48.446 120.749 48.372C114.1 47.707 108.282 52.528 106.454 56.351C104.625 60.174 102.298 77.96 102.298 81.451C102.298 84.942 104.791 91.258 111.108 91.425C115.898 91.551 119.154 89.385 120.813 87.75C120.612 87.796 120.409 87.865 120.208 87.966C118.535 88.803 115.356 90.141 111.842 90.141C108.328 90.141 104.982 88.133 104.48 83.783C103.978 79.433 105.484 73.075 106.99 71.067C108.496 69.057 108.161 65.209 108.663 64.038Z",
    fill: "black"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M128.728 71.145L128.708 71.168C130.193 67.193 132.052 61.739 132.052 59.343C132.052 55.353 127.398 49.037 120.749 48.372C114.1 47.707 108.282 52.528 106.454 56.351C104.625 60.174 102.298 77.96 102.298 81.451C102.298 84.942 104.791 91.258 111.108 91.425C117.425 91.591 121.082 87.768 121.913 86.438C122.744 85.108 125.404 80.786 125.404 80.786C126.567 80.62 129.726 79.29 129.726 79.29C132.219 78.126 131.887 74.469 131.887 71.81C131.886 69.15 128.728 71.145 128.728 71.145Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M111.566 72.972C111.566 72.972 109.398 74.806 110.065 76.474C110.732 78.142 112.733 78.642 114.067 78.308C115.401 77.974 115.568 74.473 115.568 74.473",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M108.731 80.81L113.734 82.311",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M113.901 66.636C113.901 66.636 111.9 64.635 110.232 64.301C108.565 63.968 107.23 64.134 107.23 64.134",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M117.236 67.636C117.236 67.636 118.904 66.969 121.405 67.636C123.906 68.303 124.406 69.804 124.406 69.804",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M110.715 69.064C110.564 69.832 110.039 70.376 109.542 70.278C109.045 70.18 108.764 69.479 108.915 68.71C109.066 67.942 109.591 67.398 110.088 67.496C110.585 67.594 110.866 68.296 110.715 69.064Z",
    fill: "#263238"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M119.737 71.305C119.586 72.073 119.061 72.617 118.564 72.519C118.067 72.421 117.786 71.72 117.937 70.951C118.088 70.183 118.613 69.639 119.11 69.737C119.607 69.835 119.888 70.537 119.737 71.305Z",
    fill: "#263238"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M120.749 48.372C114.1 47.707 108.282 52.528 106.454 56.351C105.756 57.811 104.985 61.309 104.298 65.269C105.434 63.736 107.617 60.66 107.617 59.676C107.617 58.346 108.614 54.689 110.942 52.362C113.269 50.035 105.622 52.8133 107.617 54.4763C109.612 56.1383 120.251 55.355 123.409 55.355C126.567 55.355 129.725 55.189 129.393 58.015C129.061 60.841 127.066 64.332 127.066 65.828C127.066 67.324 126.069 73.973 127.066 72.976C127.594 72.448 128.261 71.641 128.773 70.998C130.247 67.039 132.053 61.708 132.053 59.346C132.052 55.353 127.398 49.036 120.749 48.372Z",
    fill: "#263238"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M108.614 109.875L116.76 105.553L127.066 109.377",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M111.773 108.213L116.76 113.2L112.77 141.458L116.427 149.603L121.248 141.625L118.588 112.535L121.746 107.714L116.76 105.553L111.773 108.213Z",
    fill: "#263238"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M104.27 179.012L59.93 176.03C59.93 176.03 51.977 208.837 52.176 210.627C52.375 212.416 56.676 213.386 61.919 214.803C69.276 216.791 98.902 219.973 102.878 219.774C106.855 219.575 106.258 213.213 106.457 212.02C106.656 210.827 109.042 179.61 109.042 179.61L104.27 179.012Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 176,
    width: 58,
    height: 44
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M104.27 179.012L59.93 176.03C59.93 176.03 51.977 208.837 52.176 210.627C52.375 212.416 56.676 213.386 61.919 214.803C69.276 216.791 98.902 219.973 102.878 219.774C106.855 219.575 106.258 213.213 106.457 212.02C106.656 210.827 109.042 179.61 109.042 179.61L104.27 179.012Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.27 179.012L59.93 176.03C59.93 176.03 51.977 208.837 52.176 210.627C52.375 212.416 56.676 213.386 61.919 214.803C69.276 216.791 98.902 219.973 102.878 219.774C106.855 219.575 106.258 213.213 106.457 212.02C106.656 210.827 109.042 179.61 109.042 179.61L104.27 179.012Z",
    fill: "black"
  }))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M104.27 179.012L59.93 176.03C59.93 176.03 51.977 208.837 52.176 210.627C52.375 212.416 56.676 213.386 61.919 214.803C69.276 216.791 98.902 219.973 102.878 219.774C106.855 219.575 106.258 213.213 106.457 212.02C106.656 210.827 109.042 179.61 109.042 179.61L104.27 179.012Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M104.27 179.012C104.27 179.012 98.703 216.79 98.703 218.182C98.703 219.574 106.656 220.767 107.65 218.182C108.644 215.597 112.024 180.603 112.024 180.006C112.024 179.409 104.27 179.012 104.27 179.012Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 179,
    width: 15,
    height: 41
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M104.27 179.012C104.27 179.012 98.703 216.79 98.703 218.182C98.703 219.574 106.656 220.767 107.65 218.182C108.644 215.597 112.024 180.603 112.024 180.006C112.024 179.409 104.27 179.012 104.27 179.012Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.27 179.012C104.27 179.012 98.703 216.79 98.703 218.182C98.703 219.574 106.656 220.767 107.65 218.182C108.644 215.597 112.024 180.603 112.024 180.006C112.024 179.409 104.27 179.012 104.27 179.012Z",
    fill: "black"
  }))), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M104.27 179.012C104.27 179.012 98.703 216.79 98.703 218.182C98.703 219.574 106.656 220.767 107.65 218.182C108.644 215.597 112.024 180.603 112.024 180.006C112.024 179.409 104.27 179.012 104.27 179.012Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M90.749 95.303L107.252 174.438L105.264 197.901L108.843 198.099L111.229 173.444L95.124 93.713L90.749 95.303Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M93.654 172.044C93.654 172.044 97.477 172.044 97.976 172.044C98.475 172.044 103.295 169.052 104.791 169.052C106.287 169.052 109.612 169.218 110.941 169.218C112.27 169.218 113.102 167.888 113.102 169.55C113.102 171.212 111.107 172.21 110.11 172.376C109.113 172.542 105.29 173.041 105.29 173.041C105.29 173.041 114.1 176.532 114.432 177.031C114.765 177.53 114.931 179.691 113.767 180.023C112.603 180.355 110.609 180.688 110.609 180.688C110.609 180.688 110.11 182.35 109.778 183.514C109.445 184.678 108.282 185.176 108.282 185.176C108.282 185.176 107.118 186.506 106.287 187.004C105.456 187.503 101.799 186.838 99.804 186.339C97.809 185.84 92.656 182.516 92.158 182.183C91.659 181.85 89.332 179.523 89.332 179.523L93.654 172.044Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 168,
    width: 26,
    height: 20
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M93.654 172.044C93.654 172.044 97.477 172.044 97.976 172.044C98.475 172.044 103.295 169.052 104.791 169.052C106.287 169.052 109.612 169.218 110.941 169.218C112.27 169.218 113.102 167.888 113.102 169.55C113.102 171.212 111.107 172.21 110.11 172.376C109.113 172.542 105.29 173.041 105.29 173.041C105.29 173.041 114.1 176.532 114.432 177.031C114.765 177.53 114.931 179.691 113.767 180.023C112.603 180.355 110.609 180.688 110.609 180.688C110.609 180.688 110.11 182.35 109.778 183.514C109.445 184.678 108.282 185.176 108.282 185.176C108.282 185.176 107.118 186.506 106.287 187.004C105.456 187.503 101.799 186.838 99.804 186.339C97.809 185.84 92.656 182.516 92.158 182.183C91.659 181.85 89.332 179.523 89.332 179.523L93.654 172.044Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M93.654 172.044C93.654 172.044 97.477 172.044 97.976 172.044C98.475 172.044 103.295 169.052 104.791 169.052C106.287 169.052 109.612 169.218 110.941 169.218C112.27 169.218 113.102 167.888 113.102 169.55C113.102 171.212 111.107 172.21 110.11 172.376C109.113 172.542 105.29 173.041 105.29 173.041C105.29 173.041 114.1 176.532 114.432 177.031C114.765 177.53 114.931 179.691 113.767 180.023C112.603 180.355 110.609 180.688 110.609 180.688C110.609 180.688 110.11 182.35 109.778 183.514C109.445 184.678 108.282 185.176 108.282 185.176C108.282 185.176 107.118 186.506 106.287 187.004C105.456 187.503 101.799 186.838 99.804 186.339C97.809 185.84 92.656 182.516 92.158 182.183C91.659 181.85 89.332 179.523 89.332 179.523L93.654 172.044Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.287 187.004C107.118 186.505 108.282 185.176 108.282 185.176C108.282 185.176 109.446 184.677 109.778 183.514C110.111 182.35 110.609 180.688 110.609 180.688C110.609 180.688 112.604 180.356 113.767 180.023C114.197 179.9 114.443 179.527 114.569 179.081C112.802 178.944 110.408 178.769 109.64 178.769C108.375 178.769 108.375 182.09 108.059 183.197C107.743 184.304 106.478 185.095 104.896 184.146C103.315 183.197 93.984 179.086 93.668 178.611C93.352 178.137 94.142 174.816 94.933 174.183C95.724 173.55 101.101 170.704 101.101 170.704L100.876 170.618C99.475 171.342 98.218 172.045 97.976 172.045C97.477 172.045 93.654 172.045 93.654 172.045L89.332 179.525C89.332 179.525 91.659 181.852 92.158 182.184C92.657 182.517 97.81 185.841 99.804 186.34C101.799 186.838 105.456 187.503 106.287 187.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.217 171.652C104.58 172.126 105.29 173.041 105.29 173.041C105.29 173.041 109.113 172.542 110.111 172.376C111.108 172.21 113.103 171.212 113.103 169.55C113.103 169.469 113.1 169.4 113.096 169.333C111.995 170.509 111.293 171.251 108.217 171.652Z",
    fill: "black"
  }))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M93.654 172.044C93.654 172.044 97.477 172.044 97.976 172.044C98.475 172.044 103.295 169.052 104.791 169.052C106.287 169.052 109.612 169.218 110.941 169.218C112.27 169.218 113.102 167.888 113.102 169.55C113.102 171.212 111.107 172.21 110.11 172.376C109.113 172.542 105.29 173.041 105.29 173.041C105.29 173.041 114.1 176.532 114.432 177.031C114.765 177.53 114.931 179.691 113.767 180.023C112.603 180.355 110.609 180.688 110.609 180.688C110.609 180.688 110.11 182.35 109.778 183.514C109.445 184.678 108.282 185.176 108.282 185.176C108.282 185.176 107.118 186.506 106.287 187.004C105.456 187.503 101.799 186.838 99.804 186.339C97.809 185.84 92.656 182.516 92.158 182.183C91.659 181.85 89.332 179.523 89.332 179.523L93.654 172.044Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M91.659 169.218L94.485 171.878L89.831 180.522L87.005 178.693L91.659 169.218Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M82.683 99.071C82.683 99.071 73.541 103.061 73.042 105.055C72.543 107.05 55.424 152.23 55.424 153.893C55.424 155.555 75.203 171.047 79.359 174.538C83.515 178.029 87.005 180.023 87.005 180.023L93.488 170.382C93.488 170.382 82.172 156.952 80.344 153.628C78.515 150.303 75.96 147.506 75.96 147.506L89.333 121.179",
    fill: "#3FC7F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_282_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 99,
    width: 39,
    height: 82
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M82.683 99.071C82.683 99.071 73.541 103.061 73.042 105.055C72.543 107.05 55.424 152.23 55.424 153.893C55.424 155.555 75.203 171.047 79.359 174.538C83.515 178.029 87.005 180.023 87.005 180.023L93.488 170.382C93.488 170.382 82.172 156.952 80.344 153.628C78.515 150.303 75.96 147.506 75.96 147.506L89.333 121.179",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_282_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.005 180.023L87.9 178.692L61.901 155.751C61.901 155.751 65.118 149.316 69.944 148.995C74.77 148.673 63.188 148.995 64.153 148.352C65.118 147.709 82.492 124.544 82.492 124.544C82.492 124.544 82.814 119.718 79.918 112.318C77.022 104.918 74.127 103.953 74.127 103.953L73.988 103.872C73.477 104.305 73.129 104.71 73.043 105.055C72.544 107.05 55.425 152.23 55.425 153.893C55.425 155.555 75.204 171.047 79.36 174.538C83.514 178.028 87.005 180.023 87.005 180.023Z",
    fill: "black"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M82.683 99.071C82.683 99.071 73.541 103.061 73.042 105.055C72.543 107.05 55.424 152.23 55.424 153.893C55.424 155.555 75.203 171.047 79.359 174.538C83.515 178.029 87.005 180.023 87.005 180.023L93.488 170.382C93.488 170.382 82.172 156.952 80.344 153.628C78.515 150.303 75.96 147.506 75.96 147.506L89.333 121.179",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M110.566 211.156L115.114 201.218",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1.151 329.366H398",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/LOCATION.04f178b733cd4663fe80fcd4445a5c2d.svg";
export { ForwardRef as ReactComponent };